import React, { useEffect, useState } from 'react';
import '../styles/butterfly-animation.css';

const ButterflyAnimation = ({ onComplete }) => {
  const [butterflies, setButterflies] = useState([]);

  useEffect(() => {
    // Create 15 butterflies with random positions and delays
    const butterflyArray = Array.from({ length: 50 }, (_, i) => ({
      id: i,
      startX: Math.random() * window.innerWidth,
      startY: window.innerHeight + 50,
      endX: Math.random() * window.innerWidth,
      endY: -100,
      delay: Math.random() * 0.5,
      duration: 2.5 + Math.random() * 1.5,
      rotation: Math.random() * 360,
    }));
    
    setButterflies(butterflyArray);

    // Redirect after animation completes
    const timer = setTimeout(() => {
      if (onComplete) onComplete();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="butterfly-animation-overlay">
      {butterflies.map((butterfly) => (
        <div
          key={butterfly.id}
          className="butterfly"
          style={{
            left: `${butterfly.startX}px`,
            bottom: `-50px`,
            animationDelay: `${butterfly.delay}s`,
            animationDuration: `${butterfly.duration}s`,
            '--start-x': `${butterfly.startX}px`,
            '--end-x': `${butterfly.endX}px`,
            '--end-y': `${butterfly.endY}px`,
            '--rotation': `${butterfly.rotation}deg`,
          }}
        >
          {/* Butterfly SVG */}
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="butterfly-svg"
          >
            {/* Left wing */}
            <path
              d="M8 12C8 9 6 7 4 6C2 5 1 6 1 8C1 10 2 12 4 13C2 14 1 16 1 18C1 20 2 21 4 20C6 19 8 17 8 14V12Z"
              fill="#ff6b9d"
              className="wing-left"
            />
            {/* Right wing */}
            <path
              d="M16 12C16 9 18 7 20 6C22 5 23 6 23 8C23 10 22 12 20 13C22 14 23 16 23 18C23 20 22 21 20 20C18 19 16 17 16 14V12Z"
              fill="#ff8fab"
              className="wing-right"
            />
            {/* Body */}
            <ellipse cx="12" cy="12" rx="1.5" ry="4" fill="#c44569" />
            {/* Antennae */}
            <path
              d="M12 8C11 7 10.5 6 10.5 5"
              stroke="#c44569"
              strokeWidth="0.8"
              strokeLinecap="round"
            />
            <path
              d="M12 8C13 7 13.5 6 13.5 5"
              stroke="#c44569"
              strokeWidth="0.8"
              strokeLinecap="round"
            />
          </svg>
        </div>
      ))}
    </div>
  );
};

export default ButterflyAnimation;
